import { render, staticRenderFns } from "./Collaborators.vue?vue&type=template&id=1acf6342&scoped=true"
import script from "./Collaborators.vue?vue&type=script&lang=js"
export * from "./Collaborators.vue?vue&type=script&lang=js"
import style0 from "./Collaborators.vue?vue&type=style&index=0&id=1acf6342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acf6342",
  null
  
)

export default component.exports